module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image13.1cbbfd7b.webp";